'use client';

import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { css, cx } from 'styled-system/css';

import ShaojiangTechIcon from '@shaojiang/components/ShaojiangTechIcon';
import { Collapsible } from '@shaojiang/components/ui/collapsible';

import TechCategory from './TechCategory';

const line = css({ flex: '1', borderTopWidth: '1px', borderColor: 'border.brand' });

export default function MoreSkills() {
  const [expanded, setExpanded] = useState(false);
  return (
    <Collapsible.Root open={expanded} onOpenChange={({ open }) => setExpanded(open)}>
      <Collapsible.Trigger
        className={css({
          display: 'flex',
          alignItems: 'center',
          gap: '3',
          w: 'full',
          my: '3',
          cursor: 'pointer',
          color: 'fg.muted',
          _hover: { color: 'fg.default' },
        })}
      >
        <span className={line} />
        <span className={css({ display: 'inline-flex', alignItems: 'center', gap: '1' })}>
          <span className={css({ w: '12', textAlign: 'center' })}>
            {expanded ? 'Less' : 'More'}
          </span>
          <ChevronDown
            size={16}
            className={cx(
              css({ transition: 'transform 0.2s' }),
              expanded && css({ transform: 'rotate(180deg)' }),
            )}
          />
        </span>
        <span className={line} />
      </Collapsible.Trigger>
      <Collapsible.Content>
        <TechCategory title='UI' withTopDivider={false}>
          <ShaojiangTechIcon name='Less' />
          <ShaojiangTechIcon name='Mapbox' showName />
          <ShaojiangTechIcon name='D3' showName />
          <ShaojiangTechIcon name='FontAwesome' showName />
          <ShaojiangTechIcon name='Bootstrap' showName />
          <ShaojiangTechIcon name='Semantic-UI' showName displayedName='Sem-UI' />
          <ShaojiangTechIcon name='Jekyll' showName />
        </TechCategory>
        <TechCategory title='Data Management'>
          <ShaojiangTechIcon name='Recoil' showName />
          <ShaojiangTechIcon name='Mobx' showName />
          <ShaojiangTechIcon name='Axios' showName />
          <ShaojiangTechIcon name='Auth0' showName />
          <ShaojiangTechIcon name='Graphql' showName />
          <ShaojiangTechIcon name='NestJS' showName />
          <ShaojiangTechIcon name='Fastify' showName />
          <ShaojiangTechIcon name='Mongodb' showName />
          <ShaojiangTechIcon name='Contentful' showName />
          <ShaojiangTechIcon name='Saga' showName />
          <ShaojiangTechIcon name='WebSocket' showName />
          <ShaojiangTechIcon name='React-hook-form' showName displayedName='RHF' />
          <ShaojiangTechIcon name='Formik' showName />
        </TechCategory>
        <TechCategory title='Testing'>
          <ShaojiangTechIcon name='Jest' showName />
          <ShaojiangTechIcon name='Storybook' showName />
          <ShaojiangTechIcon name='React-testing-library' showName displayedName='RTL' />
          <ShaojiangTechIcon name='Cypress' showName height={20} />
          <ShaojiangTechIcon name='Playwright' showName />
          <ShaojiangTechIcon name='Vitest' showName />
        </TechCategory>
        <TechCategory title='Misc'>
          <ShaojiangTechIcon name='Vite' showName />
          <ShaojiangTechIcon name='Eslint' showName />
          <ShaojiangTechIcon name='Prettier' showName />
          <ShaojiangTechIcon name='Lodash' showName />
          <ShaojiangTechIcon name='Git' showName />
          <ShaojiangTechIcon name='Github' showName />
          <ShaojiangTechIcon name='Ubuntu' showName />
          <ShaojiangTechIcon name='Chrome' showName />
          <ShaojiangTechIcon name='React-i18next' showName displayedName='i18next' />
          <ShaojiangTechIcon name='AWS' />
          <ShaojiangTechIcon name='Aws-Cognito' showName displayedName='Cognito' />
          <ShaojiangTechIcon name='Aws-S3' showName displayedName='S3' />
          <ShaojiangTechIcon name='Aws-CloudFront' showName displayedName='CloudFront' />
          <ShaojiangTechIcon name='Google-tag-manager' showName displayedName='GTM' />
          <ShaojiangTechIcon name='Google-analytics' showName displayedName='GA' />
          <ShaojiangTechIcon name='Mixpanel' showName />
          <ShaojiangTechIcon name='IntelliJ-idea' showName displayedName='IntelliJ' />
        </TechCategory>
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
